var _indexOf = /*#__PURE__*/require("./_indexOf.js");
function _includes(a, list) {
  return _indexOf(list, a, 0) >= 0;
}
module.exports = _includes;